<div *ngIf="!!unitTrainList && unitTrainList.length > 0; else noData">
    <rt-multi-trip
        *ngIf="showShipments && tripIds.length > 0"
        [tripIds]="tripIds"
        [isReadOnly]="false"
        [isOpenSeparateWindow]="true"
    ></rt-multi-trip>
</div>

<ng-template #noData>
    <div style="padding: 20px; text-align: center; color: #999">No unit train selected</div>
</ng-template>
